import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const restoreDealerOrdersTracking = () => ({
  'type': ActionTypes.RESTORE_DEALER_ORDERS_TRACKING,
});

export const editDealerOrdersTrackingFilter = (field, value) => ({
  'type': ActionTypes.EDIT_DEALER_ORDERS_TRACKING_FILTER,
  'payload': {field, value},
});

export const getDealersOrdersManagement = (filters = {}) => apiActionCreator({
  'endpoint': `/orders/dealers/administration${getUrlParameters(filters)}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_DEALER_ORDERS_TRACKING_REQUEST,
    [
      ActionTypes.GET_DEALER_ORDERS_TRACKING_SUCCESS,
    ],
    [
      ActionTypes.GET_DEALER_ORDERS_TRACKING_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const downloadDealerOrderManagement = (filters) => apiActionCreator({
  'endpoint': '/orders/dealers/administration',
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOAD_DEALER_ORDERS_REQUEST,
    [
      ActionTypes.DOWNLOAD_DEALER_ORDERS_SUCCESS,
    ],
    [
      ActionTypes.DOWNLOAD_DEALER_ORDERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': filters,
});

export const deleteDealerOrder = (data) => apiActionCreator({
  'endpoint': '/orders/dealers/administration',
  'authenticated': true,
  'types': [
    ActionTypes.DELETE_DEALER_ORDER_REQUEST,
    [
      {
        'type': ActionTypes.DELETE_DEALER_ORDER_SUCCESS,
        'payload': data,
      },
    ],
    [
      ActionTypes.DELETE_DEALER_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'DELETE',
  'contentType': 'application/json',
  'data': data,
});
